import { atom } from 'recoil';
import {
  DeviceDeliCollInfoList,
  DeliveryInfo,
  CollectionInfo,
} from '@/types/api/mypage/deviceDeliCollInfo';
import persistAtom from './recoilPersist';

/**
 * 機器配送・回収一覧情報を保持する state。
 * 配送一覧画面や詳細ポップアップで共通利用するため、配送と回収の両リストをまとめて持つ。
 */
export const DeviceDeliCollInfoState = atom<DeviceDeliCollInfoList>({
  key: 'DeviceDeliCollInfoState',
  default: {
    delivery_list: [
      {
        lm_matter_id: '',
        lm_state: '',
        track_no: '',
        delivery_trader_url: '',
        delivery_pfd_date: '',
        delivery_pfd_time: '',
        device_list: [{ device_name: '' }],
        change_pfd_flg: '',
        redelivery_flg: '',
      },
    ],
    collection_list: [
      {
        lm_matter_id: '',
        lm_state: '',
        track_no: '',
        collection_pfd_date: '',
        collection_pfd_time: '',
        device_list: [{ device_name: '', device_coll_state: '', finish_flg: '' }],
        change_pfd_flg: '',
        recollection_flg: '',
      },
    ],
  },
  effects_UNSTABLE: [persistAtom],
});

/** 個別配送案件の表示・変更対象情報を保持する state。 */
export const DeliveryInfoState = atom<DeliveryInfo>({
  key: 'DeliveryInfoState',
  default: {
    lm_matter_id: '',
    lm_state: '',
    track_no: '',
    delivery_trader_url: '',
    delivery_pfd_date: '',
    delivery_pfd_time: '',
    device_list: [{ device_name: '' }],
    change_pfd_flg: '',
    redelivery_flg: '',
  },
  effects_UNSTABLE: [persistAtom],
});

/** 個別回収案件の表示・変更対象情報を保持する state。 */
export const CollectionInfoState = atom<CollectionInfo>({
  key: 'CollectionInfoState',
  default: {
    lm_matter_id: '',
    lm_state: '',
    track_no: '',
    collection_pfd_date: '',
    collection_pfd_time: '',
    device_list: [{ device_name: '', device_coll_state: '', finish_flg: '' }],
    change_pfd_flg: '',
    recollection_flg: '',
  },
  effects_UNSTABLE: [persistAtom],
});

/** 機器回収希望日時入力を保持する型。 */
export type CollectionConfigStateType = {
  desiredPickupDate: string;
};

/** 回収日時変更入力を保持する state。 */
export const CollectionConfigState = atom<CollectionConfigStateType>({
  key: 'CollectionConfigState',
  default: {
    desiredPickupDate: '',
  },
  effects_UNSTABLE: [persistAtom],
});

/** 機器配送希望日時入力を保持する型。 */
export type DeliveryConfigStateType = {
  desiredShippingDate: string;
  desiredShippingTimeZone: string;
};

/** 配送日時変更入力を保持する state。 */
export const DeliveryConfigState = atom<DeliveryConfigStateType>({
  key: 'DeliveryConfigState',
  default: {
    desiredShippingDate: '',
    desiredShippingTimeZone: '',
  },
  effects_UNSTABLE: [persistAtom],
});
